const zhCommon = {
  // Admin Common
  "admin.common.delete": "删除",
  "admin.common.edit": "编辑",
  "admin.common.add": "添加",
  "admin.common.save": "保存",
  "admin.common.cancel": "取消",
  "admin.common.confirm": "确认",
  "admin.common.loading": "加载中...",
  "admin.common.saving": "保存中...",
  "admin.common.sending": "发送中...",
  "admin.common.search": "搜索",
  "admin.common.reset": "重置",
  "admin.common.success": "操作成功",
  "admin.common.error": "操作失败",
  "admin.common.confirmDelete": "确定要删除吗？",
  "admin.common.batchDelete": "批量删除",
  "admin.common.batchApprove": "批量通过",
  "admin.common.batchReject": "批量拒绝",

  // Admin Alert
  "admin.alert.success": "操作成功",
  "admin.alert.error": "操作失败",
  "admin.alert.warning": "警告",
  "admin.alert.info": "提示",
  "admin.alert.successMessage": "您的操作已成功完成！",
  "admin.alert.errorMessage": "发生了错误，请稍后重试。",
  "admin.alert.warningMessage": "此操作不可撤销，请谨慎操作。",
  "admin.alert.infoMessage": "这是一条信息提示。",
  "admin.alert.confirm": "确认删除",
  "admin.alert.confirmMessage": "确定要删除这条记录吗？此操作无法撤销。",
  "admin.alert.autoCloseMessage": "此消息将在 3 秒后自动关闭",
  "admin.alert.toastSuccess": "保存成功！",
  "admin.alert.toastError": "保存失败，请重试",

  // Navbar
  "nav.about": "关于我们",
  "nav.partners": "合作伙伴",
  "nav.events": "活动",
  "nav.guests": "嘉宾风采",
  "nav.contact": "联系我们",
  "nav.siteName": "全球科创圆桌联盟",
  "nav.siteNameShort": "GTRA",

  // Hero
  "hero.badge": "跨国科技创新交流平台",
  "hero.title": "连接全球创新力量",
  "hero.titleHighlight": "共筑科技未来",
  "hero.subtitle": "全球科创圆桌联盟（GTRA）汇聚顶尖学者、科学家与创新企业，搭建跨越边界的国际科技合作与交流网络，共同推动人类科技文明的进步。",
  "hero.cta.learn": "了解更多",
  "hero.cta.events": "探索活动",
  "hero.cta.apply": "申请合作",
  "hero.stat1.number": "30+",
  "hero.stat1.label": "覆盖国家",
  "hero.stat2.number": "150+",
  "hero.stat2.label": "合作机构",
  "hero.stat3.number": "50+",
  "hero.stat3.label": "年度活动",

  // About Summary
  "about.badge": "关于 GTRA",
  "about.title": "使命与愿景",
  "about.description": "全球科创圆桌联盟（GTRA）成立于2020年，是一个致力于促进跨国科技创新交流与合作的国际性组织。我们汇聚全球顶尖高校、科研机构、创新企业与政策机构，通过高端圆桌论坛、国际峰会、学术交流等形式，构建连接全球创新生态的桥梁。",
  "about.stat1.number": "30+",
  "about.stat1.label": "覆盖国家",
  "about.stat2.number": "150+",
  "about.stat2.label": "合作机构",
  "about.stat3.number": "50+",
  "about.stat3.label": "年度活动",
  "about.stat4.number": "5000+",
  "about.stat4.label": "参与专家",
  "about.learnMore": "了解组织详情",

  // Partners Section (Home)
  "partners.home.badge": "全球合作伙伴",
  "partners.home.title": "携手共建创新生态",
  "partners.home.subtitle": "汇聚全球顶尖高校、科研机构与创新企业，共同驱动科技进步",
  "partners.home.viewAll": "查看全部合作伙伴",

  // Events Section (Home)
  "events.home.badge": "活动动态",
  "events.home.title": "近期活动",
  "events.home.subtitle": "探索即将举办的全球科创交流活动，与世界顶尖创新者面对面",
  "events.home.viewAll": "查看全部活动",
  "events.home.register": "立即报名",

  // Guests Section (Home)
  "guests.home.badge": "嘉宾风采",
  "guests.home.title": "特邀嘉宾",
  "guests.home.subtitle": "汇聚全球顶尖学者、科学家与创新领袖，共话科技未来",
  "guests.home.viewProfile": "查看详情",
  "guests.home.viewAll": "查看全部嘉宾",

  // Event Types
  "event.type.offline": "线下",
  "event.type.online": "线上",
  "event.type.hybrid": "混合",

  // Partners Page
  "partnersPage.hero.title": "全球合作伙伴",
  "partnersPage.hero.subtitle": "携手全球顶尖机构，共同推动科技创新与人类进步",
  "partnersPage.grid": "网格",
  "partnersPage.list": "列表",
  "partnersPage.filter.type": "按类型",
  "partnersPage.filter.region": "按地区",
  "partnersPage.type.all": "全部",
  "partnersPage.type.university": "高校",
  "partnersPage.type.research": "科研机构",
  "partnersPage.type.enterprise": "企业",
  "partnersPage.type.nonprofit": "非营利",
  "partnersPage.region.all": "全部地区",
  "partnersPage.region.asia": "亚洲",
  "partnersPage.region.europe": "欧洲",
  "partnersPage.region.americas": "美洲",
  "partnersPage.region.africa": "非洲与中东",
  "partnersPage.region.oceania": "大洋洲",
  "partnersPage.collab": "合作领域",
  "partnersPage.visitWebsite": "访问官网",
  "partnersPage.donors.badge": "感谢支持",
  "partnersPage.donors.title": "捐赠单位与个人",
  "partnersPage.donors.subtitle": "感谢来自全球各界的慷慨支持，共同助力科创事业",

  // Events Page
  "eventsPage.hero.title": "全球活动",
  "eventsPage.hero.subtitle": "探索全球科创交流活动，连接最前沿的思想与实践",
  "eventsPage.upcoming": "即将举行",
  "eventsPage.past": "历史活动",
  "eventsPage.viewPast": "查看详情",
  "eventsPage.filter.type": "活动类型",
  "eventGallery.title": "活动相册",
  "eventGallery.photos": "张照片",
  "eventGallery.photo": "张照片",
  "eventsPage.filter.month": "月份",
  "eventsPage.filter.region": "地区",
  "eventsPage.filter.all": "全部",
  "eventsPage.noEvents": "暂无符合条件的活动",
  "eventsPage.register": "立即报名",
  "eventsPage.learnMore": "了解详情",
  "eventsPage.plan.badge": "未来规划",
  "eventsPage.plan.title": "活动计划",
  "eventsPage.plan.subtitle": "展望未来，持续扩展全球科创交流版图",

  // Footer
  "footer.description": "全球科创圆桌联盟（GTRA）——连接全球创新力量，共筑科技未来。通过高端论坛、圆桌对话与国际合作，推动跨国科技创新。",
  "footer.quickLinks": "快速链接",
  "footer.contactUs": "联系我们",
  "footer.subscribe.title": "订阅最新资讯",
  "footer.subscribe.desc": "获取 GTRA 最新活动、研究动态与合作机会",
  "footer.subscribe.placeholder": "输入您的邮箱地址",
  "footer.subscribe.btn": "订阅",
  "footer.subscribe.success": "订阅成功，感谢您的关注！",
  "footer.copyright": "© 2026 全球科创圆桌联盟（GTRA）。保留所有权利。",
  "footer.address": "Melenhorst 5, Losser",
  "footer.email": "info@gtraweb3.com",
  "footer.phone": "+1 2672435802",

  // Common
  "common.readMore": "了解更多",
  "common.viewAll": "查看全部",
  "common.close": "关闭",
  "common.loading": "加载中...",
  "common.lang.zh": "中文",
  "common.lang.en": "EN",

  // Donate
  "nav.donate": "捐赠支持",

  // Event Modal
  "eventModal.tab.overview": "活动概览",
  "eventModal.tab.agenda": "活动议程",
  "eventModal.tab.speakers": "演讲嘉宾",
  "eventModal.tab.register": "在线报名",
  "eventModal.agenda.type.keynote": "主旨演讲",
  "eventModal.agenda.type.panel": "圆桌讨论",
  "eventModal.agenda.type.workshop": "工作坊",
  "eventModal.agenda.type.break": "茶歇",
  "eventModal.agenda.type.ceremony": "典礼",
  "eventModal.register.name": "姓名",
  "eventModal.register.email": "邮箱",
  "eventModal.register.org": "所属机构",
  "eventModal.register.phone": "联系电话",
  "eventModal.register.type": "参与方式",
  "eventModal.register.type.offline": "线下参与",
  "eventModal.register.type.online": "线上参与",
  "eventModal.register.message": "备注（可选）",
  "eventModal.register.submit": "提交报名",
  "eventModal.register.success": "报名成功！我们将在近期与您联系确认。",
  "eventModal.register.ph.name": "请输入您的姓名",
  "eventModal.register.ph.email": "请输入您的邮箱地址",
  "eventModal.register.ph.org": "请输入您的机构名称",
  "eventModal.register.ph.phone": "请输入您的联系电话",
  "eventModal.register.ph.message": "其他需要备注的信息（500字以内）",

  // Guests Page
  "guestsPage.hero.badge": "特邀嘉宾",
  "guestsPage.hero.title": "嘉宾风采",
  "guestsPage.hero.subtitle": "汇聚全球顶尖学者、科学家与创新领袖，共话科技未来",
  "guestsPage.filter.year": "按年份",
  "guestsPage.filter.expertise": "按领域",
  "guestsPage.filter.country": "按国家",
  "guestsPage.filter.all": "全部",
  "guestsPage.year.all": "全部年份",
  "guestsPage.count": "位嘉宾",
  "guestsPage.viewProfile": "查看详情",
  "guestsPage.modal.bio": "个人简介",
  "guestsPage.modal.expertise": "研究领域",
  "guestsPage.modal.awards": "所获荣誉",
  "guestsPage.modal.publications": "代表性论文",
  "guestsPage.modal.pubCount": "篇",
  "guestsPage.modal.close": "关闭",
  "guestsPage.modal.events": "参与活动记录",
  "guestsPage.modal.events.role": "参与角色",
  "guestsPage.modal.events.empty": "暂无活动记录",

  // Partners Detail Modal
  "partnerModal.detail": "机构详情",
  "partnerModal.collab": "合作方向",
  "partnerModal.projects": "合作项目",
  "partnerModal.stats.years": "合作年限",
  "partnerModal.stats.projects": "联合项目",
  "partnerModal.stats.experts": "参与专家",
  "partnerModal.viewSite": "访问官网",
  "partnerModal.close": "关闭",

  // Partnership Apply Form
  "partnersPage.apply.badge": "加入我们",
  "partnersPage.apply.title": "申请合作",
  "partnersPage.apply.subtitle": "填写合作意向表，我们将在3个工作日内与您联系洽谈合作细节",
  "partnersPage.apply.form.orgName": "机构名称 *",
  "partnersPage.apply.form.orgType": "机构类型 *",
  "partnersPage.apply.form.orgType.university": "高校/学术机构",
  "partnersPage.apply.form.orgType.research": "科研机构",
  "partnersPage.apply.form.orgType.enterprise": "企业/创业公司",
  "partnersPage.apply.form.orgType.nonprofit": "非营利组织",
  "partnersPage.apply.form.orgType.government": "政府/公共机构",
  "partnersPage.apply.form.contactName": "联系人姓名 *",
  "partnersPage.apply.form.contactTitle": "联系人职务",
  "partnersPage.apply.form.email": "联系邮箱 *",
  "partnersPage.apply.form.phone": "联系电话",
  "partnersPage.apply.form.country": "所在国家/地区 *",
  "partnersPage.apply.form.domain": "拟合作领域 *",
  "partnersPage.apply.form.domain.ai": "人工智能与机器学习",
  "partnersPage.apply.form.domain.quantum": "量子计算",
  "partnersPage.apply.form.domain.biotech": "生物技术与健康",
  "partnersPage.apply.form.domain.climate": "气候与可持续发展",
  "partnersPage.apply.form.domain.energy": "清洁能源",
  "partnersPage.apply.form.domain.space": "航空航天",
  "partnersPage.apply.form.domain.other": "其他领域",
  "partnersPage.apply.form.intention": "合作意向说明 *",
  "partnersPage.apply.form.submit": "提交申请",
  "partnersPage.apply.form.success": "申请已提交！我们将在3个工作日内与您联系。",
  "partnersPage.apply.form.ph.orgName": "请输入机构全称",
  "partnersPage.apply.form.ph.contactName": "请输入联系人姓名",
  "partnersPage.apply.form.ph.contactTitle": "请输入联系人职务",
  "partnersPage.apply.form.ph.email": "请输入联系邮箱",
  "partnersPage.apply.form.ph.phone": "请输入联系电话（选填）",
  "partnersPage.apply.form.ph.country": "请输入所在国家或地区",
  "partnersPage.apply.form.ph.intention": "请简述您的合作意向、希望开展的合作形式及预期目标（500字以内）",
  "partnersPage.apply.perks.title": "加入 GTRA 合作网络",
  "partnersPage.apply.perks.p1.title": "全球网络接入",
  "partnersPage.apply.perks.p1.desc": "与30+国家150+顶尖机构建立直接联系",
  "partnersPage.apply.perks.p2.title": "高端活动参与",
  "partnersPage.apply.perks.p2.desc": "优先参与年度峰会、圆桌论坛及专项研讨会",
  "partnersPage.apply.perks.p3.title": "联合研究机会",
  "partnersPage.apply.perks.p3.desc": "参与跨机构、跨学科前沿研究合作项目",
  "partnersPage.apply.perks.p4.title": "品牌曝光提升",
  "partnersPage.apply.perks.p4.desc": "在全球科创社区中获得更高的机构知名度与影响力",

  // Media Coverage
  "media.badge": "媒体报道",
  "media.title": "全球媒体关注",
  "media.subtitle": "GTRA 的探索与实践，已引发全球顶尖媒体与学术刊物的广泛关注与深度报道",
  "media.readMore": "阅读全文",

  // About Page Reports
  "aboutPage.reports.badge": "知识沉淀",
  "aboutPage.reports.title": "年度报告与白皮书",
  "aboutPage.reports.subtitle": "GTRA每年发布研究报告、白皮书与政策简报，系统记录全球科创生态进展，为政策制定者、研究者与创新者提供权威参考",

  // Guests Modal Similar
  "guestsPage.modal.similar": "相似嘉宾推荐",
  "aboutPage.hero.badge": "关于我们",
  "aboutPage.hero.title": "关于全球科创圆桌联盟",
  "aboutPage.hero.subtitle": "连接全球创新力量，推动人类科技进步，共建开放包容的科技创新生态",
  "aboutPage.mission.badge": "使命愿景",
  "aboutPage.mission.title": "我们的使命",
  "aboutPage.mission.desc1": "全球科创圆桌联盟（GTRA）成立于2020年，是一个致力于促进跨国科技创新交流与合作的国际性非营利组织。我们相信，开放的科技创新交流是推动人类文明进步最重要的力量之一。",
  "aboutPage.mission.desc2": "通过汇聚来自全球30余个国家和地区的顶尖高校、科研机构、创新企业与政府机构，GTRA搭建起连接全球创新生态的桥梁，打造科技创新领域的最高规格国际对话平台。",
  "aboutPage.mission.v1.title": "开放包容",
  "aboutPage.mission.v1.desc": "欢迎来自不同背景、不同领域的创新者加入，共享知识与智慧",
  "aboutPage.mission.v2.title": "合作共赢",
  "aboutPage.mission.v2.desc": "推动跨机构、跨学科、跨国界的深度合作，共同应对人类重大挑战",
  "aboutPage.mission.v3.title": "求真创新",
  "aboutPage.mission.v3.desc": "坚持科学精神，鼓励突破性思维，推动前沿科技的探索与应用",
  "aboutPage.timeline.badge": "发展历程",
  "aboutPage.timeline.title": "GTRA 的成长足迹",
  "aboutPage.team.badge": "核心团队",
  "aboutPage.team.title": "我们的团队",
  "aboutPage.team.subtitle": "来自全球顶尖机构的专业人士，共同推动 GTRA 的使命与愿景",
  "aboutPage.team.executive": "执行团队",
  "aboutPage.team.advisory": "顾问委员会",
  "aboutPage.contact.badge": "联系我们",
  "aboutPage.contact.title": "与我们联系",
  "aboutPage.contact.subtitle": "无论是合作咨询、媒体联系还是一般询问，我们都期待与您交流",
  "aboutPage.contact.form.name": "姓名 *",
  "aboutPage.contact.form.email": "邮箱 *",
  "aboutPage.contact.form.subject": "主题",
  "aboutPage.contact.form.message": "留言内容 *",
  "aboutPage.contact.form.submit": "发送消息",
  "aboutPage.contact.form.success": "感谢您的留言！我们将在2个工作日内回复您。",
  "aboutPage.contact.form.ph.name": "请输入您的姓名",
  "aboutPage.contact.form.ph.email": "请输入您的邮箱地址",
  "aboutPage.contact.form.ph.subject": "请输入咨询主题",
  "aboutPage.contact.form.ph.message": "请输入您的留言内容（500字以内）",

  // Admin Email Config
  "admin.emailConfig.title": "邮件配置",
  "admin.emailConfig.description": "配置联系表单邮件的 SMTP 设置",
  "admin.emailConfig.add": "添加配置",
  "admin.emailConfig.addConfig": "添加配置",
  "admin.emailConfig.editConfig": "编辑配置",
  "admin.emailConfig.noConfigs": "未找到邮件配置",
  "admin.emailConfig.active": "已激活",
  "admin.emailConfig.from": "发件人",
  "admin.emailConfig.to": "收件人",
  "admin.emailConfig.setActive": "设为激活",
  "admin.emailConfig.edit": "编辑",
  "admin.emailConfig.delete": "删除",
  "admin.emailConfig.smtpHost": "SMTP 服务器",
  "admin.emailConfig.smtpPort": "SMTP 端口",
  "admin.emailConfig.smtpUser": "SMTP 用户名",
  "admin.emailConfig.smtpPass": "SMTP 密码",
  "admin.emailConfig.fromEmail": "发件邮箱",
  "admin.emailConfig.fromName": "发件人名称",
  "admin.emailConfig.toEmail": "收件邮箱",
  "admin.emailConfig.setAsActive": "设为激活配置",
  "admin.emailConfig.cancel": "取消",
  "admin.emailConfig.save": "保存",

  // Admin Subscriptions
  "admin.subscriptions.title": "订阅管理",
  "admin.subscriptions.description": "管理新闻邮件订阅者",
  "admin.subscriptions.total": "总订阅数",
  "admin.subscriptions.active": "活跃订阅",
  "admin.subscriptions.unsubscribed": "已退订",
  "admin.subscriptions.filterAll": "全部",
  "admin.subscriptions.filterActive": "仅活跃",
  "admin.subscriptions.filterUnsubscribed": "仅退订",
  "admin.subscriptions.searchPlaceholder": "搜索邮箱...",
  "admin.subscriptions.email": "邮箱",
  "admin.subscriptions.status": "状态",
  "admin.subscriptions.source": "来源",
  "admin.subscriptions.subscribedAt": "订阅时间",
  "admin.subscriptions.unsubscribedAt": "退订时间",
  "admin.subscriptions.actions": "操作",
  "admin.subscriptions.statusActive": "活跃",
  "admin.subscriptions.statusUnsubscribed": "已退订",
  "admin.subscriptions.noData": "暂无订阅数据",
  "admin.subscriptions.confirmDelete": "确定要删除该订阅吗？",
  "admin.subscriptions.deleteSuccess": "删除成功",
  "admin.subscriptions.deleteFailed": "删除失败",
  "admin.subscriptions.sendNewsletter": "发送新闻邮件",
  "admin.subscriptions.emailSubject": "邮件主题",
  "admin.subscriptions.emailContent": "邮件内容",
  "admin.subscriptions.subjectPlaceholder": "输入邮件主题...",
  "admin.subscriptions.contentPlaceholder": "输入邮件内容（支持HTML）...",
  "admin.subscriptions.recipientInfo": "将发送给 {{count}} 位活跃订阅者",
  "admin.subscriptions.fillAllFields": "请填写所有字段",
  "admin.subscriptions.emailQueued": "邮件发送任务已启动",
  "admin.subscriptions.sendFailed": "发送失败",
  "admin.subscriptions.send": "发送",
  "admin.subscriptions.send": "发送",
  "admin.subscriptions.tabSubscriptions": "订阅管理",
  "admin.subscriptions.tabHistory": "发送历史",
  "admin.subscriptions.historyNoData": "暂无发送记录",
  "admin.subscriptions.historySubject": "邮件主题",
  "admin.subscriptions.historyRecipientCount": "发送结果",
  "admin.subscriptions.historyStatus": "状态",
  "admin.subscriptions.historyCreatedBy": "发送人",
  "admin.subscriptions.historyCreatedAt": "发送时间",
  "admin.subscriptions.historyStatus_completed": "已完成",
  "admin.subscriptions.historyStatus_sending": "发送中",
  "admin.subscriptions.historyStatus_failed": "失败",
  "admin.subscriptions.historyStatus_completed_with_errors": "部分失败",
  "admin.common.pageInfo": "第 {{page}} 页，共 {{total}} 页",
  "admin.common.prevPage": "上一页",
  "admin.common.nextPage": "下一页",
  "admin.common.sending": "发送中...",

  // Not Found Page
  "notFound.title": "您访问的页面不存在",
  "notFound.description": "抱歉，您访问的页面可能已被移除或地址有误",
  "notFound.goHome": "返回首页",
  "notFound.goBack": "返回上页",
  "notFound.viewEvents": "查看活动",
  "notFound.quickLinks": "快速链接",
  "notFound.help": "如果您认为这是一个错误，请",
  "notFound.contactUs": "联系我们",
  "nav.home": "首页",

  // Team Member Modal
  "teamPage.modal.biography": "个人简介",
  "teamPage.modal.viewLinkedIn": "查看 LinkedIn 主页",
  "teamPage.modal.close": "关闭",
};

export default zhCommon;
